import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imCategoryFilter', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/filters/category-filter/category-filter.html'),
        controller: 'CompanyConfigurationCategoriesController',
        controllerAs: 'CategoryFilterCtrl',
        bindings: {
            category: '=',
            pickFirst: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/filters/category-filter/category-filter.component.ts